// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".checkboxWrapper--ESX_l{display:flex;flex-direction:column}", "",{"version":3,"sources":["webpack://./src/pages/ContractDetails/RightPanel/Statuses/components/TerminateStatus/terminate-container.module.scss"],"names":[],"mappings":"AAEA,wBACE,YAAA,CACA,qBAAA","sourcesContent":["@import '@/assets/styles/global/variables';\n\n.checkboxWrapper {\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkboxWrapper": "checkboxWrapper--ESX_l"
};
export default ___CSS_LOADER_EXPORT___;
